/* Step 13 · P6.1 (owner, 03-Nov-2026: "OBVIOUSLY ONE NUMBER") — an engagement whose latest report version is Final, or which is
   locked, prints the note numbers kept when it went Final on EVERY output (this screen, Validation, the Publication PDF, Excel /
   Word, the report's references); the statement replies carry `note_numbers_kept` = { source, as_at, basis } and the screen says
   so in one small line, EN + AR. */
import React from "react";
import { fmtDate } from "@/lib/dt";

export function noteNumbersKept(...replies) {
  return replies.map((r) => r && r.note_numbers_kept).find(Boolean) || null;
}

export default function NoteNumbersKept({ kept, t }) {
  if (!kept) return null;
  const date = kept.as_at ? fmtDate(kept.as_at) : "";   // fmtDate isolates the date (LTR inside Arabic) itself
  const key = kept.basis === "locked" ? "noteNumbersKept.locked" : kept.basis === "publication" ? "noteNumbersKept.publication" : "noteNumbersKept.final";
  return (
    <p className="text-xs text-muted-foreground" data-testid="ifrs-note-numbers-kept">
      {t(key).replace("{date}", date || "—")}
    </p>
  );
}
